angular.module('gym.gocardless').controller('LogsParamsModalCtrl', ["$scope", "$modalInstance", "params", "title", function($scope, $modalInstance, params, title) {
  $scope.params = params;
  $scope.title = title;
  return $scope.close = function() {
    return $modalInstance.dismiss('cancel');
  };
}]);
